import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";
import { ValidationIcon_default } from "./chunk-N7RSLTZJ.js";
import { ValidationMessage_default } from "./chunk-ZQDBVQVV.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableField/CheckableField.Validation.tsx
import { useContext } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var CheckableFieldValidation = _a => {
  var _b = _a,
    {
      role = "alert",
      className
    } = _b,
    rest = __objRest(_b, ["role", "className"]);
  const {
    id,
    validation,
    validationMessage
  } = useContext(CheckableFieldContext);
  if (!validation) {
    return null;
  }
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd:checkable-field__validation", className),
    children: [/* @__PURE__ */jsx(ValidationIcon_default, {
      variant: validation,
      className: "pd:checkable-field__validation-icon"
    }), /* @__PURE__ */jsx(ValidationMessage_default, {
      variant: validation,
      role,
      id: "".concat(id, "-validation-message"),
      className: "pd:checkable-field__validation-message",
      children: validationMessage
    })]
  }));
};
var CheckableField_Validation_default = CheckableFieldValidation;
export { CheckableField_Validation_default };